import React, { FunctionComponent, useState } from 'react';

import { IAuthorData } from '../../../utils/authorsDataResolver';
import {
  SectionHeader,
  ISectionHeaderProps
} from '../../section-header/section-header';
import { BlogAuthorBox } from './blog-author-box/blog-author-box';
import { Button, IButtonProps } from '../../button/button';
import { ButtonLoader } from '../../button-loader/button-loader';

import styles from './blog-author-list.module.scss';

export interface IBlogAuthorListProps {
  allAuthors: boolean;
  header: ISectionHeaderProps;
  authors: IAuthorData[] | undefined;
  button: IButtonProps;
  showAllAuthors?: boolean;
}

const BlogAuthorListComponent: FunctionComponent<IBlogAuthorListProps> = props => {
  const { header, authors, button, showAllAuthors } = props;
  const authorsNumber = showAllAuthors ? 6 : 3;
  const authorsList = (authors && authors) || [];
  !showAllAuthors && authorsList.sort(() => Math.random() - Math.random());
  const [authorsToShow, setAuthorsToShow] = useState(
    authorsList.slice(0, authorsNumber)
  );

  const showMore = (): void => {
    setAuthorsToShow(
      authorsList.slice(0, authorsToShow.length + authorsNumber)
    );
  };

  return (
    <section className={`${styles.sectionWrapper}`}>
      <div className={styles.container}>
        {header && <SectionHeader {...header} />}
        <div className={styles.authorsWrapper}>
          {authorsToShow &&
            authorsToShow.map((author: IAuthorData, i: number) => (
              <BlogAuthorBox data={author} key={i} hideLinks={showAllAuthors} />
            ))}
        </div>

        {showAllAuthors && authorsToShow.length !== authorsList.length ? (
          <div className={styles.loader}>
            <ButtonLoader buttonText="Load More" onClick={showMore} />
          </div>
        ) : (
          button && (
            <div className={styles.button}>
              <Button {...button} />
            </div>
          )
        )}
      </div>
    </section>
  );
};

export const BlogAuthorList = React.memo(BlogAuthorListComponent);
